import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Performer } from 'globals/store/performers.data';
import { PublicEventInfo, PublicTimelineItem } from 'globals/store/public.model';
import { publicHelpers } from './../../helpers/public-helpers';
import { EntityProfileComponent } from 'src/app/components/entities/program-entity-profile.component';
import { CommonModule } from '@angular/common';
import { PhotoComponent } from 'src/app/components/photo';
@Component({
    selector: 'performer-gallery',
    template: `
<div class="empty-entities-note" *ngIf="isPreview && !performerList.length" [innerHTML]="publicHelpers.strWithBreak(emptyMessage)"></div>
<div *ngIf="!selectedPerformerId && !!performerList.length" class="performers-holder">
  <div class="performer-card smooth" *ngFor="let performer of performerList" (click)="showPerformer(performer.id)">
    <photo *ngIf="!hidePhotos" [size]="120" [data]="{title: performer.name, photoURL:performer.fullPhotoUrl || performer.photoUrl}"></photo>
    <div class="performer-title ellipsis" [title]="performer.name" [ngClass]="{hidePhotos: hidePhotos}">{{ performer.name }}</div>
    <div class="performer-line ellipsis" [title]="performer.line1" *ngIf="performer.line1">{{ performer.line1 }}</div>
    <div class="performer-line ellipsis" [title]="performer.line2" *ngIf="performer.line2">{{ performer.line2 }}</div>
  </div>
</div>
<div *ngIf="!selectedPerformerId" class="performers-list mobile">
  <div class="performer-business-card" *ngFor="let performer of performerList" (click)="showPerformer(performer.id)">
    <photo *ngIf="!hidePhotos" [size]="60" [data]="{title: performer.name, photoURL: performer.photoUrl}"></photo>
    <div class="details">
      <div class="performer-title ellipsis">{{ performer.name }}</div>
      <div class="performer-line ellipsis" *ngIf="performer.line1">{{ performer.line1 }}</div>
      <div class="performer-line ellipsis" *ngIf="performer.line2">{{ performer.line2 }}</div>
  </div>
  </div>
</div>
<entity-profile
  *ngIf="joiEvent?.profilePerformers && joiEvent.profilePerformers[selectedPerformerId] as performer"
  [backLabel]="entityName" 
  [labelMap]="joiEvent.performer_labels"
  [sessionsTitle]="'Sessions with ' + performer.name + ':'"
  [sessions]="sessions"
  [performer]="performer"
  [name]="performer.name"
  [hideLabels]="performer.hideLabels"
  [hideImages]="!!performer.photoHidden"
  [labels]="performer.labels"
  [social]="performer.social"
  [description]="performer.bio"
  [logoUrl]="performer.fullLogoUrl || performer.logoUrl"
  [programTexts]="programTexts"
  [joiEvent]="joiEvent"
  (goBack)="selectedPerformerId = null"
></entity-profile>
`,
    styleUrls: ['./performer-gallery.scss'],
    standalone: true,
    imports: [EntityProfileComponent, CommonModule, PhotoComponent],
})
export class PerformerGalleryComponent {
  @Input() performerList: Performer[] = []
  @Input() joiEvent: PublicEventInfo
  @Input() timeline: PublicTimelineItem[][]
  @Input() programTexts = {}
  @Input() hidePhotos = false
  @Input() hideSessions = false
  @Input() isPreview = false
  @Input() entityName
  emptyMessage = "Note: This performers page has no content to display and will be hidden when you publish.\n\nTo include this page, add performers and assign them to a session, or adjust the <b>Filter Timeline</b> controls."
  publicHelpers = publicHelpers
  selectedPerformerId: string
  sessions: PublicTimelineItem[] = []
  @Output() scrollUp: EventEmitter<void> = new EventEmitter()

  showPerformer(performerId: string) {
    this.selectedPerformerId = performerId
    this.setTimeline()    
    this.scrollUp.emit()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.joiEvent) { // only fires if joiEvent is an input
      const event: PublicEventInfo = changes.joiEvent.currentValue
      this.performerList = !event.profilePerformers ? [] : Object.values(event.profilePerformers).sort(
        (p1, p2) => p1.name.toLocaleUpperCase() < p2.name.toLocaleUpperCase() ? -1 : 1)
    }
    if (this.selectedPerformerId) this.setTimeline()
  }

  setTimeline() {
    this.sessions = []
    if (this.hideSessions) return
    this.timeline.forEach(day => day.forEach(session => {
      if (session.performerIds.includes(this.selectedPerformerId)) this.sessions.push(session)
    }))
  }

}




